import { useBranding } from '@/hooks/useBranding'
import parkezeMark from '@/assets/parkeze-mark.png'

/**
 * The Parkeze signature under an operator's brand (logbook decision 26): the
 * Parkeze mark at the text's height, then "Powered by Parkeze", in the muted
 * text color, linking to parkeze.com. Shown whenever the record in force says
 * `powered_by`, which is every operator's record and not Parkeze's own, and
 * shown on phones too; it is never larger than the operator's identity in the
 * header.
 */
export function PoweredByParkeze() {
  const { brand } = useBranding()
  if (!brand.powered_by) return null

  return (
    <footer className="shrink-0 flex justify-center border-t border-border bg-card px-4 py-1.5 pb-[max(0.375rem,env(safe-area-inset-bottom))]">
      <a
        href="https://parkeze.com"
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center gap-1.5 text-xs leading-none text-muted-foreground hover:text-foreground transition-colors"
      >
        <img src={parkezeMark} alt="" className="h-[1em] w-[1em]" />
        Powered by Parkeze
      </a>
    </footer>
  )
}
